/* eslint-disable @typescript-eslint/member-ordering */
import { ChangeDetectionStrategy, Component, computed, inject, input, InputSignal, ResourceRef, Signal } from '@angular/core';
import { rxResource, toSignal } from '@angular/core/rxjs-interop';
import { AlertComponent } from '@libs/common/components';
import { CartQueueItem, CartService } from '@libs/shared/services';
import {
  CartModel,
  ConfigurableBundleAddToCartModel,
  ConfigurableBundleTemplateModel,
  ShopProductListItemBaseModel,
} from '@libs/shop/models';
import { ConfigurableBundleRepositoryService } from '../services';
import { ConfigurableBundleFormComponent } from './configurable-bundle-form';
import { ConfigurableBundlesSkeletonComponent } from './configurable-bundles-skeleton';

@Component({
  selector: 'ui-configurable-bundles',
  imports: [
    AlertComponent,
    ConfigurableBundleFormComponent,
    ConfigurableBundlesSkeletonComponent,
  ],
  templateUrl: './configurable-bundles.component.html',
  styleUrl: './configurable-bundles.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfigurableBundlesComponent {
  private readonly repo: ConfigurableBundleRepositoryService = inject(ConfigurableBundleRepositoryService);
  private readonly cartService: CartService = inject(CartService);
  private readonly cart: Signal<CartModel | undefined> = toSignal(this.cartService.getCart());
  private readonly cartQueue: Signal<CartQueueItem[]> = toSignal(this.cartService.getCartQueue(), { initialValue: [] });

  public templateId: InputSignal<string> = input.required();
  public isAddToCartLoading: Signal<boolean> = computed(() => this.cartQueue().length > 0);

  public cartItem: Signal<ShopProductListItemBaseModel | undefined> = computed(() => {
    return this.cart()?.items.find((item) => item.configuredBundleTemplateId === this.templateId());
  });

  public resource: ResourceRef<ConfigurableBundleTemplateModel | undefined> = rxResource({
    params: () => this.templateId(),
    stream: ({ params: templateId }) => this.repo.getById(templateId),
    defaultValue: undefined,
  });

  public addToCart(data: ConfigurableBundleAddToCartModel): void {
    this.cartService.queueConfigurableBundle(data);
  }
}
